import { useEffect } from 'react';

const CHATWOOT_ENABLED = process.env.REACT_APP_ENABLE_CHATWOOT !== 'false';
const CHATWOOT_BASE_URL = process.env.REACT_APP_CHATWOOT_BASE_URL;
const CHATWOOT_WEBSITE_TOKEN = process.env.REACT_APP_CHATWOOT_WEBSITE_TOKEN;

const ChatwootWidget = () => {

  useEffect(() => {

    console.log('CHATWOOT_ENABLED', CHATWOOT_ENABLED)
    console.log('CHATWOOT_BASE_URL', CHATWOOT_BASE_URL)
    console.log('CHATWOOT_WEBSITE_TOKEN', CHATWOOT_WEBSITE_TOKEN)
    if (!CHATWOOT_ENABLED) return;
    // Evitar inyección duplicada del script
    if (document.getElementById('chatwoot-sdk')) return;

    const script = document.createElement('script');
    script.id = 'chatwoot-sdk';
    script.src = `${CHATWOOT_BASE_URL}/packs/js/sdk.js`;
    script.async = true;
    script.onload = () => {
      if (window.chatwootSDK) {
        window.chatwootSDK.run({
          websiteToken: CHATWOOT_WEBSITE_TOKEN,
          baseUrl: CHATWOOT_BASE_URL
        });
      }
    };
    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('chatwoot-sdk');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default ChatwootWidget;

